const cdnURL = process.env.VUE_APP_CDN_URL || 'https://drp-01-space.fra1.cdn.digitaloceanspaces.com'
const env = process.env.VUE_APP_MEDIA_UPLOAD_DIRECTORY || 'development'

export default {
	methods: {
		getMediaThumbnailURL (media) {
			if (!media || !media.thumbnail || !media.thumbnail.filename) {
				return null
			}
			return `${cdnURL}/${env}/media/${media._id}/thumbnail/${media.thumbnail.filename}`
		},
		getMediaOriginalURL (media) {
			if (!media || !media.original || !media.original.filename) {
				return null
			}
			return `${cdnURL}/${env}/media/${media._id}/original/${media.original.filename}`
		},
		getMediaProcessedURL (media) {
			if (!media || !media.processed || !media.processed.filename) {
				return null
			}
			return `${cdnURL}/${env}/media/${media._id}/processed/${media.processed.filename}`
		},
		getMediaTypeForMIMEType (mimeType) {
			switch (mimeType) {
			case 'image/jpeg':
			case 'image/png':
			case 'image/gif':
			case 'image/svg+xml':
				return 'image'
			case 'audio/mp3':
			case 'audio/mp4':
			case 'video/mp4':
			case 'audio/mpeg':
			case 'audio/wav':
			case 'audio/ogg':
			case 'application/ogg':
			case 'video/ogg':
				return 'audio'
			default:
				return null
			}
		}
	}
}
